/**
 * Product identity. The platform is reusable Wipro IP — the product name is fixed,
 * while the client name comes from per-engagement branding (shown as "Prepared for …").
 */
export const PRODUCT_NAME = 'Wipro Data Maturity Assessment';

/**
 * Brand gradient, derived from the Wipro thumbnail (navy → indigo → blue → teal → cyan).
 * Mirrors --grad-brand in index.css for the rare spot that needs it as an inline style.
 */
export const BRAND_GRADIENT =
  'linear-gradient(120deg,#0A1B4D 0%,#2A2F86 28%,#1E5FD6 52%,#0EA5B7 78%,#22D3EE 100%)';
